export default "__VITE_ASSET__f0aa5642__"